import { getClient } from '../environment';
import { ScoreboardType } from '../sports/types';
import { ClientName } from './types';

export enum EventType {
    Bootstrap = 'bootstrap',
    Login = 'login',
    LoginRequired = 'loginRequired',
    PlaceBetClicked = 'placeBetClicked',
    BetPlaced = 'betPlaced',
    Cashout = 'cashout',
}

export function dispatchEvent(event: EventType, params?) {
    if (window.coolb2b?.events) {
        const customEvent = new CustomEvent(event, { detail: params });
        window.coolb2b.events.dispatchEvent(customEvent);
        console.log('[B2B] event:', event, params);
    }
}

export function isScoreboardEnabled(scoreboardType: ScoreboardType, requiredScoreboardType?: ScoreboardType) {
    const client = getClient();
    const enabledScoreboardsByClient = {
        [ClientName.IVC]: [ScoreboardType.betgenius],
        [ClientName.WYNNBET]: [ScoreboardType.betgenius],
    };

    return (
        (requiredScoreboardType ? scoreboardType === requiredScoreboardType : true) &&
        (enabledScoreboardsByClient[client] ? enabledScoreboardsByClient[client].includes(scoreboardType) : true)
    );
}
